import { Component, Input, OnInit } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatMomentDateModule,
  provideMomentDateAdapter,
} from '@angular/material-moment-adapter';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { RegisterCo2FacilityForm } from '@facility';
import _default from 'chart.js/dist/core/core.interaction';
import index = _default.modes.index;
import { MatFormFieldModule } from '@angular/material/form-field';

const MONTH_DAY_FORMAT = {
  parse: {
    dateInput: 'DD.MM',
  },
  display: {
    dateInput: 'DD.MM',
    monthYearLabel: 'MMM',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'MMM',
  },
};

@Component({
  selector: 'app-maintenance-window',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    TranslateModule,
  ],
  providers: [MatDatepickerModule, provideMomentDateAdapter(MONTH_DAY_FORMAT)],
  templateUrl: './maintenance-window.component.html',
  styleUrl: './maintenance-window.component.scss',
})
export class MaintenanceWindowComponent implements OnInit {
  @Input()
  public index: number;
  @Input()
  public lastIndex: number;

  public form: FormGroup<RegisterCo2FacilityForm>;

  constructor(private readonly parentFormGroup: FormGroupDirective) {}

  public ngOnInit() {
    this.form = this.parentFormGroup.control;
  }
}
